module.exports = __webpack_public_path__ + "img/banner.2c90d24c.svg";